import type { Collection } from 'state/utils/types';
import type { WorkspaceType } from 'state/workspaces/model';

export type QuoteType =
  | 'Indicative'
  | 'AdvancedIndicative'
  | 'Tradable'
  | 'AdvancedTradable'
  | 'Executable'
  | 'AdvancedExecutable'
  | 'ExecOnly'
  | 'AdvancedExecOnly'
  | BookingType;

export type BookingType = 'BookWithExecution' | 'BookWithoutExecution';

export type DashboardWorkspaceType = 'static' | 'dynamic';

export function isDashboardWorkspace(workspace: WorkspaceType): workspace is DashboardWorkspaceType {
  return workspace === 'static' || workspace === 'dynamic';
}

export type QuoteState = 'Live' | 'Previous' | 'Inconsistent';

// Collection is indexed by 'quoteId'
export type QuoteInfos = Readonly<{
  quoteType?: QuoteType;
  bookingType?: BookingType;
  workspace: DashboardWorkspaceType;
  isLoadingPrevious?: boolean;
  lastUpdated: Date;
}>;

export type QuoteInfosMap = Collection<QuoteInfos>;

export const initialQuoteInfos: QuoteInfosMap = {};
